<div class="modal-header border-0">
  <button type="button" class="btn-close" (click)="modalRef.hide()"></button>
</div>
<div class="modal-body">
  <div class="col-12 my-3">
    <ng-container *ngFor="let item of numerairesTypes; let i = index">
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" name="numeraire" id="numeraire{{i}}" [value]="item.value"
          [(ngModel)]="numeraireValue" (change)="isAccount = null; loadForm()" [disabled]="item.disabled">
        <label class="form-check-label" for="numeraire{{i}}">
          {{item.name}}
        </label>
      </div>
    </ng-container>
  </div>
  <div class="col-12 my-3">
    <ng-container *ngIf="numeraireValue === 'BRL'">
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" name="isAccount" id="card" [value]="false" [(ngModel)]="isAccount"
          (change)="loadForm()">
        <label class="form-check-label" for="card">
          Cartão
        </label>
      </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" name="isAccount" id="account" [value]="true"
          [(ngModel)]="isAccount" (change)="loadForm()">
        <label class="form-check-label" for="account">
          Conta corrente / Poupança
        </label>
      </div>
    </ng-container>
  </div>

  <form *ngIf="formGroup?.value" [formGroup]="formGroup" class="row gap-0 row-gap-3" (submit)="submit()"
    autocomplete="off" novalidate>
    <!-- SELECT CONNECTION IF IS ACCOUNT -->
    <div class="form-group col-12 col-md-8 col-lg-5 col-xl-3" *ngIf="isAccount">
      <label for="account">Conta</label>
      <select class="form-select" (change)="onSelectAccount($event.target.value)" formControlName="account_uuid"
        [ngModelOptions]="{standalone: true}">
        <option [value]="undefined" selected>
          Selecione a conta
        </option>
        <ng-container *ngFor="let conn of connections">
          <optgroup [label]="conn.name">
            <ng-container *ngFor="let acc of conn.accounts">
              <option [value]="acc.uuid"
                *ngIf="acc.account_type === (extractOptions.checking || extractOptions.savings)">
                {{conn.name}} &#10132; {{ acc.number }} - {{ getAccountLabel(acc) }}
              </option>
            </ng-container>
          </optgroup>
        </ng-container>
      </select>
      <invalid-feedback [field]="f.account_uuid"></invalid-feedback>
    </div>
    <div class="form-group col-12 col-md-6 col-lg-4">
      <label for="transaction_date">Data de pagamento</label>
      <input type="text" Mask="##/##/####" [bsConfig]="bsConfig" bsDatepicker class="form-control"
        placeholder="DD/MM/YYYY" formControlName="transaction_date">
      <invalid-feedback [field]="f.transaction_date"></invalid-feedback>
    </div>
    <div class="form-group col-12 col-md-6 col-lg-4">
      <label for="name">Nomear</label>
      <input type="text" class="form-control" formControlName="name">
      <invalid-feedback [field]="f.name"></invalid-feedback>
    </div>
    <div class="form-group col-12 col-md-6 col-lg-4">
      <label for="category">Categoria</label>
      <select class="form-select" formControlName="category">
        <option value="">Selecione...</option>
        <option *ngFor="let item of categories" [value]="item.category">
          {{item.description}}
        </option>
      </select>
    </div>
    <div class="form-group col-12 col-md-6 col-lg-4">
      <label for="subcategory">Subcategoria</label>
      <select class="form-select" formControlName="subcategory">
        <option value="">Selecione...</option>
        <ng-container *ngFor="let item of subCategories">
          <option *ngIf="f.category?.value === item.category" [value]="item.subcategory">
            {{item.description}}
          </option>
        </ng-container>
      </select>
    </div>
    <div class="form-group col-12 col-md-6 col-lg-4">
      <label for="type">Tipo</label>
      <select class="form-select" formControlName="type">
        <option value="debit">Despesa</option>
        <option value="credit">Receita</option>
      </select>
      <invalid-feedback [field]="f.type"></invalid-feedback>
    </div>
    <div class="form-group col-12 col-md-6 col-lg-4">
      <label for="amount">Valor</label>
      <input type="text" currencyMask [options]="currencyOption" class="form-control" placeholder="R$ 0,00"
        formControlName="amount">
      <invalid-feedback [field]="f.amount"></invalid-feedback>
    </div>

    <!-- EFETIVAS -->
    <ng-container *ngIf="numeraireValue === 'BRL'; else budget">
      <!-- CARTÃO -->
      <ng-container *ngIf="isAccount === false">
        <div class="form-group col-12 col-md-6 col-lg-4">
          <label for="card_uuid">Cartão</label>
          <select class="form-select" formControlName="card_uuid" (change)="onSelectCard($event.target.value)">
            <option [value]="undefined">Selecione...</option>
            <ng-container *ngFor="let conn of connections">
              <option *ngFor="let card of conn.cards" [value]="card.uuid">
                {{card.identification_number}} - {{card.name}}
              </option>
            </ng-container>
          </select>
          <invalid-feedback [field]="f.card_uuid"></invalid-feedback>
        </div>
        <div class="form-group col-12 col-md-6 col-lg-4">
          <label for="installment">Parcelas</label>
          <select class="form-select" formControlName="installment">
            <option [value]="undefined">Selecione...</option>
            <option *ngFor="let item of [].constructor(12); let i = index" [value]="i + 1">
              {{i + 1}}
            </option>
          </select>
        </div>
      </ng-container>
    </ng-container>

    <!-- ORÇADAS -->
    <ng-template #budget>
      <div class="form-group col-6 col-md-4 col-lg-2">
        <label for="frequency">Repetir</label>
        <select class="form-select" formControlName="frequency">
          <option value="">Selecione...</option>
          <option *ngFor="let item of listRecurrence" [value]="item.value">
            {{item.name}}
          </option>
        </select>
        <invalid-feedback [field]="f.frequency"></invalid-feedback>
      </div>
      <div class="form-group col-6 col-md-4 col-lg-2">
        <label for="repetitions">Nº de ocorrências</label>
        <input type="number" max="999" class="form-control" formControlName="repetitions">
      </div>
    </ng-template>
    <!-- <ng-container *ngIf="type === 'transfer'">
        <div class="form-group col-12 col-md-6 col-lg-4">
          <label for="name">Nomear</label>
          <input type="text" class="form-control" placeholder="Nome" formControlName="name">
          <invalid-feedback [field]="f.name"></invalid-feedback>
        </div>
        <div class="form-group col-12 col-md-6 col-lg-4">
          <label for="outgoing_account">Conta de saída</label>
          <select class="form-select" formControlName="outgoing_account">
            <option value="">Selecione...</option>
            <option *ngFor="let item of items">
              {{item}}
            </option>
          </select>
          <invalid-feedback [field]="f.outgoing_account"></invalid-feedback>
        </div>
        <div class="form-group col-12 col-md-6 col-lg-4">
          <label for="incoming_account">Conta de entrada</label>
          <select class="form-select" formControlName="incoming_account">
            <option value="">Selecione...</option>
            <option *ngFor="let item of items">
  
            </option>
          </select>
          <invalid-feedback [field]="f.incoming_account"></invalid-feedback>
        </div>
        <div class="form-group col-12 col-md-6 col-lg-4">
          <label for="value">Valor</label>
          <input type="text" currencyMask [options]="currencyOption" class="form-control" placeholder="R$ 0,00"
            formControlName="value">
          <invalid-feedback [field]="f.value"></invalid-feedback>
        </div>
        <div class="form-group col-12 col-md-6 col-lg-4">
          <label for="date">Data</label>
          <input type="text" Mask="##/##/####" [bsConfig]="bsConfig" bsDatepicker class="form-control"
            placeholder="DD/MM/YYYY" formControlName="date">
          <invalid-feedback [field]="f.date"></invalid-feedback>
        </div>
      </ng-container> -->
    <div class="col-12 text-center mt-3">
      <button type="button" class="btn btn-outline-dark" data-dismiss="modal" (click)="modalRef.hide()">VOLTAR</button>
      <button type="submit" class="btn btn-primary">SALVAR</button>
    </div>
  </form>
</div>